module.exports = __webpack_public_path__ + "static/media/resume.ec6af515.pdf";